/**
 * Events menu: clickable list of events/custom events to go inside mp-drop-menu
 */

import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SelectDropdown} from 'common/components/select/index';
import {SelectAttrs} from 'common/components/select/types';

import {template} from './template';
import './index.styl';

type FilterDropdownWrapperState = {
  handleFilterChange: () => void;
};

type FilterDropdownWrapperAttrs = SelectAttrs & {'empty-label': string};

export class FilterDropdownWrapper extends Component<FilterDropdownWrapperState, FilterDropdownWrapperAttrs> {
  static get attrsSchema(): AttrsSchema<FilterDropdownWrapperAttrs> {
    return {
      ...SelectDropdown.attrsSchema,
      'empty-label': `string`,
    };
  }

  filterChangeHandler = null;

  get config() {
    return {
      template,
    };
  }

  set handleFilterChange(handleFilterChange) {
    this.filterChangeHandler = handleFilterChange;
  }
}

export const FilterDropdownWrapperEl = defineAndMakeJsxFactory(`mp-filter-dropdown-wrapper`, FilterDropdownWrapper);
export const FilterDropdownWrapperReact = panel2react(`mp-filter-dropdown-wrapper`, FilterDropdownWrapper);
